import { Analytics } from '@cobliteam/analytics';

import type { UUID } from '@cobliteam/common-types';
import { useActiveTrigger } from '@cobliteam/hooks/src/useEntity/useAlerts';
import { Button, Dialog, Typography } from '@cobliteam/ui/components';
import { useEffect } from 'react';

interface TriggerEnableDialogProps {
  triggerId: UUID;
  open: boolean;
  setOpen: (open: boolean) => void;
  onCancel?: () => void;
}

const TriggerEnableDialog = ({ triggerId, open, setOpen, onCancel }: TriggerEnableDialogProps) => {
  const { isPending, isSuccess, isError, mutate } = useActiveTrigger(triggerId, true);

  useEffect(() => {
    if (!isPending && (isSuccess || isError)) {
      setOpen(false);
      onCancel?.();
    }
  }, [isPending, isSuccess, isError, setOpen]);

  const handleConfirmEnableRule = () => {
    mutate();
    Analytics.track('Rule Enable Clicked');
  };

  return (
    <Dialog open={open}>
      <Dialog.Content modalSize='sm'>
        <Dialog.Header>
          <Dialog.Title>Ativar o uso da regra</Dialog.Title>
          <Dialog.Description className='sr-only' />
          <Dialog.Close
            onClick={() => {
              setOpen(false);
              onCancel?.();
            }}
          />
        </Dialog.Header>

        <Dialog.Body>
          <Typography variant='description-list-default'>
            Ao <b>ativar</b> a regra, novos acionamentos poderão ser gerados para todos os usuários inseridos na regra e aparecerão no histórico disponível na página inicial.
          </Typography>
        </Dialog.Body>

        <Dialog.Footer className='flex justify-end gap-4'>
          <Dialog.Close asChild>
            <Button
              variant='ghost'
              onClick={() => {
                setOpen(false);
                onCancel?.();
              }}
            >
              Cancelar
            </Button>
          </Dialog.Close>
          <Dialog.Close asChild>
            <Button onClick={handleConfirmEnableRule} loading={isPending}>
              Ativar regra
            </Button>
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
};

export default TriggerEnableDialog;
